import { render } from "./CarrierHistory.vue?vue&type=template&id=0d4269e2&scoped=true"
import script from "./CarrierHistory.vue?vue&type=script&lang=js"
export * from "./CarrierHistory.vue?vue&type=script&lang=js"

import "./CarrierHistory.vue?vue&type=style&index=0&id=0d4269e2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4269e2"]])

export default __exports__